import { USER_COOKIE_CONSENT } from 'constants/index';

export default function consentToCookies(params) {
  return {
    type: USER_COOKIE_CONSENT,
    payload: params,
  };
}
